export function marketoForms() {
    let marketo = window.MktoForms2;

    if (marketo) {
        let isDefaultLang = 'en_US';
        if (document.querySelector('meta[property="og:locale"]')) {
            isDefaultLang = document.querySelector('meta[property="og:locale"]').getAttribute('content')
        }

        $('.marketo-create').each(function () {
            let $form = $(this);
            let formId = $form.data('form-id');
            let protocol = "https:";
            let instanceURL = $form.data('instance-url');
            let munchkinId = $form.data('munchkin-id');
            let translatedJsonUrl = $form.data('translated-json-url');
            let hasTranslatedJson = (translatedJsonUrl !== undefined) && (translatedJsonUrl !== '');
            let extConfig = {
                baseURL: instanceURL + "/js/forms2/",
                ajaxPostURL: $form.data('ajax-post-url'),
                htmlActionURL: protocol + instanceURL + $form.data('html-action-url'),
                descriptorURL: instanceURL + "/index.php/form/getForm?" +
                    "munchkinId=" + munchkinId +
                    "&form=" + formId +
                    "&url=" + encodeURIComponent(document.location.href) +
                    "&callback=" + "loadMktoFormSync"
            };

            let createForm = function (descriptor) {
                descriptor.action = extConfig.htmlActionURL;

                MktoForms2.setOptions({
                    rootUrl: instanceURL,
                    baseUrl: extConfig.baseURL,
                    formSubmitPath: extConfig.ajaxPostURL
                });

                MktoForms2.newForm(descriptor, function (form) {
                    form.addHiddenFields({
                        munchkinId: munchkinId
                    });
                    form.render();
                    form.getFormElem()[0].setAttribute("data-mkto-ready", "true");
                });
            }

            window.loadMktoFormSync = createForm.bind(this);

            if (isDefaultLang || !hasTranslatedJson) {
                let fetchDescriptor = document.createElement("script");

                fetchDescriptor.src = extConfig.descriptorURL;
                document.head.appendChild(fetchDescriptor);
            } else {
                $.getJSON(translatedJsonUrl, createForm.bind(this));
            }

            MktoForms2.whenReady(function ($form) {
                const form = $form.getFormElem();
                const button = form.find('.mktoButton');
                const buttonText = button.text();
                button.replaceWith(`<button type="submit" class="mktoButton button"><span data-label="${buttonText}"><span>${buttonText}</span></span></button>`)

                if (form.find('textarea').length) {
                    form.find('textarea').closest('.mktoFormRow').addClass('full-width');
                }

                if (form.find('.mktoHtmlText').length) {
                    form.find('.mktoHtmlText').closest('.mktoFormRow').addClass('full-width');
                }
                form.on('change', function () {
                    if (form.find('textarea').length) {
                        form.find('textarea').closest('.mktoFormRow').addClass('full-width');
                    }

                    if (form.find('.mktoHtmlText').length && form.find('.mktoCheckboxList').length === 0) {
                        form.find('.mktoHtmlText').closest('.mktoFormRow').addClass('full-width');
                    }
                });
            });
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/marketoForms.js